export enum AudienceRetention {
  r30d = "30d",
  r90d = "90d",
  r180d = "180d",
  r365d = "365d",
  forever = "forever",
}

export interface Audience {
  id: number;
  "workspace-id": number;
  "owner-id": number;
  name: string;
  description: string;
  retention: AudienceRetention;
  "generate-lookalikes?": boolean;
  "created-at": string;
  "updated-at": string;
}
